import React from 'react'
import Poster from '../Poster/Poster'
import Work from '../Work/Work'
import About from '../About/About'
import Services from '../Services/Services'
import Why from '../Why/Why'
import Team from '../Team/Team'
import Testimonial from '../Testimonial/Testimonial'
import FAQ from '../Faq/Faq'
import Connect from '../Connect/Connect'
import Homepage from '../Homepage/Homepage'
import '../Home/Home.css'



const Home = () => {
  return (
    <>


       <Poster/>
      <Work/> 
      <About/> 
      <Services/>
      <Why/>
      <Team/>
      <Testimonial/>
      <Connect/>
      <FAQ/>

    </>
  )
}

export default Home